<div>
	<h1 class="h2 mb-4">{{'nav.admin.time_lost_report' | translate}}</h1>
	<sct-custom-table
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>
</div>
